// apps/paz-corporate/lib/mapConfig.ts
export type MapType = 'corporate' | 'charge' | 'yellowMarket';


export interface MapConfig {
    // Basic configuration
    title?: string;
    showTitle: boolean;
    showBreadcrumbs: boolean;

    // Filter configuration
    defaultFilters: number[];

    // Tracking events
    trackingPrefix: string;

    // Export configuration
    exportHeaders: string[];
    exportTitle: string;

    // Map behavior
    defaultZoom: number;
    defaultCenter: { lat: number; lng: number };

    // Visual configuration
    primaryColor: string;
    secondaryColor: string;
}

export enum LocatorMapType {
    Corporate = "Corporate",
    Charge = "Charge"
}
